module.exports = function () {
    $(document).ready(function (event) {

        $(document).on('click', '.btn-add', function(e)
        {
            e.preventDefault();

            var fieldName = $('#new_location_input').val();
            var fieldNameSmall = fieldName.toLowerCase();

            if (fieldName != '') {

                var newFieldGroup =
                    '<div class="col-xs-12">' +
                        '<div class="report-section-header">Communal area (' + fieldName + '):</div>' +
                    '</div>' +
                    '<div class="col-sm-2 mb-20 text-center"><strong>Name</strong></div>\n' +
                    '<div class="col-sm-2 mb-20 text-center"><strong>Condition</strong></div>\n' +
                    '<div class="col-sm-5 mb-20 text-center"><strong>Notes</strong></div>\n' +
                    '<div class="col-sm-3 mb-20 text-center"><strong>File (max. 100MB)</strong></div>\n' +

                    '<div class="col-xs-2 align-middle">Door</div>\n' +
                    '<div class="col-xs-2">\n' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Door][condition]" value="1" class="form-checkbox">Good' +
                                '</div>' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Door][condition]" value="0" class="form-checkbox">Not Good' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-5">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<textarea name="location['+ fieldName +'][Door][notes]" cols="50" rows="10"></textarea>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<input class="form-control" name="location['+ fieldName +'][Door][files]" type="file">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="clearfix"></div>' +
                    '<div class="col-xs-2 align-middle">Wall</div>\n' +
                    '<div class="col-xs-2">\n' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Wall][condition]" value="1" class="form-checkbox">Good' +
                                '</div>' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Wall][condition]" value="0" class="form-checkbox">Not Good' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-5">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<textarea name="location['+ fieldName +'][Wall][notes]" cols="50" rows="10"></textarea>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<input class="form-control" name="location['+ fieldName +'][Wall][files]" type="file">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="clearfix"></div>' +
                    '<div class="col-xs-2 align-middle">Ceiling</div>\n' +
                    '<div class="col-xs-2">\n' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Ceiling][condition]" value="1" class="form-checkbox">Good' +
                                '</div>' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Ceiling][condition]" value="0" class="form-checkbox">Not Good' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-5">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<textarea name="location['+ fieldName +'][Ceiling][notes]" cols="50" rows="10"></textarea>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<input class="form-control" name="location['+ fieldName +'][Ceiling][files]" type="file">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="clearfix"></div>' +
                    '<div class="col-xs-2 align-middle">Window(s)</div>\n' +
                    '<div class="col-xs-2">\n' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Window(s)][condition]" value="1" class="form-checkbox">Good' +
                                '</div>' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Window(s)][condition]" value="0" class="form-checkbox">Not Good' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-5">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<textarea name="location['+ fieldName +'][Window(s)][notes]" cols="50" rows="10"></textarea>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<input class="form-control" name="location['+ fieldName +'][Window(s)][files]" type="file">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="clearfix"></div>' +
                    '<div class="col-xs-2 align-middle">Floor</div>\n' +
                    '<div class="col-xs-2">\n' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Floor][condition]" value="1" class="form-checkbox">Good' +
                                '</div>' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Floor][condition]" value="0" class="form-checkbox">Not Good' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-5">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<textarea name="location['+ fieldName +'][Floor][notes]" cols="50" rows="10"></textarea>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<input class="form-control" name="location['+ fieldName +'][Floor][files]" type="file">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="clearfix"></div>' +
                    '<div class="col-xs-2 align-middle">Light(s)</div>\n' +
                    '<div class="col-xs-2">\n' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Light(s)][condition]" value="1" class="form-checkbox">Good' +
                                '</div>' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Light(s)][condition]" value="0" class="form-checkbox">Not Good' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-5">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<textarea name="location['+ fieldName +'][Light(s)][notes]" cols="50" rows="10"></textarea>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<input class="form-control" name="location['+ fieldName +'][Light(s)][files]" type="file">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="clearfix"></div>' +
                    '<div class="col-xs-2 align-middle">Fire extinguisher(s)</div>\n' +
                    '<div class="col-xs-2">\n' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Fire extinguisher(s)][condition]" value="1" class="form-checkbox">Good' +
                                '</div>' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Fire extinguisher(s)][condition]" value="0" class="form-checkbox">Not Good' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-5">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<textarea name="location['+ fieldName +'][Fire extinguisher(s)][notes]" cols="50" rows="10"></textarea>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<input class="form-control" name="location['+ fieldName +'][Fire extinguisher(s)][files]" type="file">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="clearfix"></div>' +
                    '<div class="col-xs-2 align-middle">Plug socket(s)</div>\n' +
                    '<div class="col-xs-2">\n' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Plug socket(s)][condition]" value="1" class="form-checkbox">Good' +
                                '</div>' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Plug socket(s)][condition]" value="0" class="form-checkbox">Not Good' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-5">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<textarea name="location['+ fieldName +'][Plug socket(s)][notes]" cols="50" rows="10"></textarea>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<input class="form-control" name="location['+ fieldName +'][Plug socket(s)][files]" type="file">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="clearfix"></div>' +
                    '<div class="col-xs-2 align-middle">Other</div>\n' +
                    '<div class="col-xs-2">\n' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Other][condition]" value="1" class="form-checkbox">Good' +
                                '</div>' +
                                '<div class="checklist_radio">' +
                                    '<input type="radio" name="location['+ fieldName +'][Other][condition]" value="0" class="form-checkbox">Not Good' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-5">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<textarea name="location['+ fieldName +'][Other][notes]" cols="50" rows="10"></textarea>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="col-xs-3">' +
                        '<div class="form-group">' +
                            '<div class="col-xs-12">' +
                                '<input class="form-control" name="location['+ fieldName +'][Other][files]" type="file">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="clearfix"></div>';

                var locationForm = $('.locations');

                $(newFieldGroup).appendTo(locationForm);

                $('#new_location_input').val('');
            }

        }).on('click', '.btn-remove', function(e)
        {
            $(this).parents('.row:first').remove();

            e.preventDefault();
            return false;
        });

    });
}();